"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function extendRecursive(a, b, deleteNull, noOverwrite) {
  var assignVal = function assignVal(a, opt, val) {
    if (val === null && deleteNull) {
      delete a[opt];
    } else {
      if (Array.isArray(val)) {
        if (noOverwrite && Object.hasOwnProperty.call(a, opt)) {
          return;
        }

        if (!Object.hasOwnProperty.call(a, opt) || !Array.isArray(a[opt]) || a[opt] === undefined) {
          a[opt] = [];
        } else {
          a[opt].length = 0;
        }

        for (var i = 0; i < val.length; i++) {
          assignVal(a[opt], i, val[i]);
        }
      } else if ((0, _typeof2["default"])(val) === 'object') {
        if (!Object.hasOwnProperty.call(a, opt) || (0, _typeof2["default"])(a[opt]) !== 'object') {
          a[opt] = {};
        }

        extendRecursive(a[opt], val, deleteNull, noOverwrite);
      } else if (!(noOverwrite && Object.hasOwnProperty.call(a, opt))) {
        if (a === undefined) {
          console.log(a, ',', opt, ',', val);
        }

        a[opt] = val;
      }
    }
  };

  if (b) {
    for (var opt in b) {
      if (Object.hasOwnProperty.call(b, opt) && opt[0] !== '_') {
        assignVal(a, opt, b[opt]);
      }
    }
  }

  return a;
}

function setOnPath(o, path, value) {
  var s = o;
  var p = path.split('.');

  for (var i = 0; i < p.length; i++) {
    var fn = p[i];

    if (!Object.hasOwnProperty.call(s, fn)) {
      return false;
    }

    if (i === p.length - 1) {
      if (value === null) {
        delete s[fn];
      } else {
        s[fn] = value;
      }
    } else {
      s = s[fn];
    }
  }

  return true;
}

function compareByValue(a, b) {
  return JSON.stringify(a) === JSON.stringify(b);
}

function getFromPath(o, path) {
  var s = o;
  var p = path.split('.');

  var _iterator = _createForOfIteratorHelper(p),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var fn = _step.value;

      if (!Object.hasOwnProperty.call(s, fn)) {
        return undefined;
      }

      s = s[fn];
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return s;
}

var workToDo = [];
var worker = null;

function handleWork() {
  var start = Date.now();

  while (Date.now() - start < 20 && workToDo.length > 0) {
    workToDo.shift()();
  }

  if (workToDo.length > 0) {
    worker = window.requestAnimationFrame(handleWork);

    if (window.amdebug) {
      console.log('resceduled: ', Date.now() - start);
    }
  } else {
    worker = null;
  }
}

function sceduleWork(f) {
  workToDo.push(f);

  if (!worker) {
    worker = window.requestAnimationFrame(handleWork);
  }
}

function sceduleWorkBefore(f) {
  if (f.constructor === Array) {
    Array.prototype.unshift.apply(workToDo, f);
  } else {
    workToDo.unshift(f);
  }

  if (!worker) {
    worker = window.requestAnimationFrame(handleWork);
  }
}

var effectTemplates = {
  transparantColor: {
    defaultValue: {
      color: {
        r: 255,
        g: 255,
        b: 255
      },
      margin: 0.1
    },
    minValue: {
      color: {
        r: 0,
        g: 0,
        b: 0
      },
      margin: 0.0
    },
    maxValue: {
      color: {
        r: 255,
        g: 255,
        b: 255
      },
      margin: 1.0
    },
    init: 'var clr = msg.effects.transparantColor.color;' + 'var margin = msg.effects.transparantColor.margin;' + 'var d1=0,d2=0,d3=0,dist=0;',
    body: 'bw = r * .30 + g * .59 + b * .11;' + 'd1 = clr.r - r;' + 'd2 = clr.g - g;' + 'd3 = clr.b - b;' + 'dist = Math.sqrt(d1*d1+d2*d2+d3*d3)/441.7;' + 'a = (dist<=margin?0:255);'
  },
  optimizeColors: {
    defaultValue: {
      colors: [{
        r: 255,
        g: 255,
        b: 255
      }],
      smooth: 0.75,
      highPrecisionTreshold: 0.2
    },
    minValue: {
      colors: [{
        r: 0,
        g: 0,
        b: 0
      }],
      smooth: 0.0,
      highPrecisionTreshold: 0.0
    },
    maxValue: {
      colors: [{
        r: 255,
        g: 255,
        b: 255
      }],
      smooth: 1.0,
      highPrecisionTreshold: 1.0
    },
    init: 'var bkColor = msg.effects.optimizeColors.colors;' + 'var smooth = 0.5 - 0.5 * msg.effects.optimizeColors.smooth;' + 'var highPercTreshold = 0.5 - 0.5 * msg.effects.optimizeColors.highPrecisionTreshold;' + 'var cr=0,cg=0,cb=0, i=0, nc = bkColor[0];' + 'var s2 = smooth*4.0;' + 'var m=1.0+s2*2.0;' + 'for (i = 0, nc; i < bkColor.length; i++) {' + 'nc = bkColor[i];' + 'var mf = 255/Math.sqrt(nc.r*nc.r+nc.g*nc.g+nc.b*nc.b+384.0);' + 'nc.nr = nc.r*mf;' + 'nc.ng = nc.g*mf;' + 'nc.nb = nc.b*mf;' + '}',
    body: 'var minDist1 = 255*255*255;' + 'var minDist2 = 255*255*255;' + 'var clrIX1 = 0;' + 'var clrIX2 = 0;' + 'for (i = 0; i < bkColor.length; i++)' + '{' + 'nc = bkColor[i];' + 'cr = r - nc.r;' + 'cg = g - nc.g;' + 'cb = b - nc.b;' + 'var dist = (cr * cr + cg * cg + cb * cb);' + 'if (dist < minDist1)' + '{' + 'minDist1 = dist;' + 'clrIX1 = i;' + '}' + '}' + 'var oc1 = bkColor[clrIX1];' + 'if (minDist1<24) {' + 'r = oc1.r;' + 'g = oc1.g;' + 'b = oc1.b;' + '} else {' + 'for (i = 0; i < bkColor.length; i++)' + '{' + 'if (i != clrIX1) {' + 'nc = bkColor[i];' + 'cr = r - nc.r;' + 'cg = g - nc.g;' + 'cb = b - nc.b;' + 'var dist = (cr * cr + cg * cg + cb * cb);' + 'if (dist < minDist2)' + '{' + 'minDist2 = dist;' + 'clrIX2 = i;' + '}' + '}' + '}' + 'var oc2 = bkColor[clrIX2];' + 'var f1 = minDist1/(minDist1+minDist2);' + 'if (f1<highPercTreshold) {' + 'f1 = Math.max(0.0,f1-smooth);' + 'var f2 = 1.0-f1;' + 'r = oc1.r*f2 + oc2.r*f1;' + 'g = oc1.g*f2 + oc2.g*f1;' + 'b = oc1.b*f2 + oc2.b*f1;' + '} else {' + 'var minDist3 = minDist1;' + 'var nc1,nc2;' + 'for (i = 0; i < bkColor.length; i++)' + '{' + 'nc1 = bkColor[i];' + 'var par = r-nc1.r;' + 'var pag = g-nc1.g;' + 'var pab = b-nc1.b;' + 'for (j = 0; j < bkColor.length; j++)' + '{' + 'if (i != j) {' + 'nc2 = bkColor[j];' + 'var bar = nc2.r - nc1.r;' + 'var bag = nc2.g - nc1.g;' + 'var bab = nc2.b - nc1.b;' + 'var he = (par*bar+pag*bag+pab*bab)/(bar*bar+bag*bag+bab*bab);' + 'he = Math.min(Math.max(he,0),1);' + 'bar *= he;' + 'bag *= he;' + 'bab *= he;' + 'cr = bar - par;' + 'cg = bag - pag;' + 'cb = bab - pab;' + 'var dist = (cr * cr + cg * cg + cb * cb);' + 'if (dist < minDist3)' + '{' + 'minDist3 = dist;' + 'clrIX1 = i;' + 'clrIX2 = j;' + '}' + '}' + '}' + '}' + 'if (minDist3<minDist1) {' + 'nc1 = bkColor[clrIX1];' + 'nc2 = bkColor[clrIX2];' + 'cr = r - nc1.r;' + 'cg = g - nc1.g;' + 'cb = b - nc1.b;' + 'minDist1 = (cr * cr + cg * cg + cb * cb);' + 'cr = r - nc2.r;' + 'cg = g - nc2.g;' + 'cb = b - nc2.b;' + 'minDist2 = (cr * cr + cg * cg + cb * cb);' + 'if (minDist1>minDist2) {' + 'var dist = minDist1;' + 'minDist1 = minDist2;' + 'minDist2 = dist;' + 'oc1 = nc2;' + 'oc2 = nc1;' + '} else {' + 'oc1 = nc1;' + 'oc2 = nc2;' + '}' + '}' + 'f1 = minDist1/(minDist1+minDist2);' + 'f1 = Math.max(0.0,f1-smooth);' + 'var f2 = 1.0-f1;' + 'r = oc1.r*f2 + oc2.r*f1;' + 'g = oc1.g*f2 + oc2.g*f1;' + 'b = oc1.b*f2 + oc2.b*f1;' + '}' + '}' + 'a = Math.min(Math.max(m*a-s2,0.0),255.0);'
  },
  saturation: {
    defaultValue: 1.0,
    minValue: 0.0,
    maxValue: 2.0,
    init: 'var sat = msg.effects.saturation;' + 'if (sat>1.0) sat *= sat;' + 'var nsat = 1.0 - sat;' + 'var bw = 0;',
    body: 'bw = r * .30 + g * .59 + b * .11;' + 'r = (r * sat) + (nsat * bw);' + 'g = (g * sat) + (nsat * bw);' + 'b = (b * sat) + (nsat * bw);'
  },
  brightness: {
    defaultValue: 0.0,
    minValue: -1.0,
    maxValue: 1.0,
    init: 'var brg = 255 * msg.effects.brightness;',
    body: 'r += brg;' + 'g += brg;' + 'b += brg;'
  },
  contrast: {
    defaultValue: 1.0,
    minValue: 0.0,
    maxValue: 2.0,
    init: 'var contrast = msg.effects.contrast;',
    body: 'r -= 127; g -= 127; b -= 127;' + 'r *= contrast; g *= contrast; b *= contrast;' + 'r += 127; g += 127; b += 127;'
  },
  curve: {
    defaultValue: -0.1,
    minValue: -1.2,
    maxValue: 1.0,
    init: 'var pwr = -0.1-msg.effects.curve;' + 'var bw = 0;',
    body: 'bw = r * .30 + g * .59 + b * .11;' + 'bw = Math.pow(bw / 255, pwr);' + 'r *= bw;' + 'g *= bw;' + 'b *= bw;'
  },
  hue: {
    defaultValue: Math.PI,
    minValue: 0.0,
    maxValue: 2 * Math.PI,
    init: 'var cosVal = Math.cos(msg.effects.hue+Math.PI);' + 'var sinVal = Math.sin(msg.effects.hue+Math.PI);' + 'var lR = .30;' + // 0.213;'
    'var lG = .59;' + // 0.715;'
    'var lB = .11;' + // 0.072;'
    'var rr = lR+cosVal*(1-lR)+sinVal*(-lR);' + 'var rg = lG+cosVal*(-lG)+sinVal*(-lG);' + 'var rb = lB+cosVal*(-lB)+sinVal*(1-lB);' + 'var gr = lR+cosVal*(-lR)+sinVal*(0.143);' + 'var gg = lG+cosVal*(1-lG)+sinVal*(0.140);' + 'var gb = lB+cosVal*(-lB)+sinVal*(-0.283);' + 'var br = lR+cosVal*(-lR)+sinVal*(-(1-lR));' + 'var bg = lG+cosVal*(-lG)+sinVal*(lG);' + 'var bb = lB+cosVal*(1-lB)+sinVal*(lB);',
    body: 'var rn = r*rr + g*rg + b*rb;' + 'var gn = r*gr + g*gg + b*gb;' + 'var bn = r*br + g*bg + b*bb;' + 'r=rn;g=gn;b=bn;'
  },
  intensity: {
    defaultValue: 1.0,
    minValue: 0.0,
    maxValue: 1.0,
    init: 'var intens = msg.effects.intensity;' + 'var nintens = 1.0-intens;',
    body: 'r = nintens * d[o] + intens * r;' + 'g = nintens * d[o + 1] + intens * g;' + 'b = nintens * d[o + 2] + intens * b;' + 'a = nintens * d[o + 3] + intens * a;'
  },
  blur: {
    defaultValue: {
      top: 0.0,
      gradual: 0.02,
      radius: 0.0,
      preserveEdges: 0.0,
      centerX: -0.01,
      centerY: -0.01
    },
    minValue: {
      top: 0.0,
      gradual: 0.0,
      radius: 0.0,
      preserveEdges: 0.0,
      centerX: -0.01,
      centerY: -0.01
    },
    maxValue: {
      top: 1.0,
      gradual: 1.0,
      radius: 5.0,
      preserveEdges: 1.0,
      centerX: 1.0,
      centerY: 1.0
    },
    preEffect: function preEffect(segmentData, segHeight, left, top, width, height, params) {
      var offset = params.top;
      if (offset < 0.000001) offset = -1.0;
      var radius = params.radius / 100.0 * width; // var len = width * height;

      var circleCenter = null;

      if (params.centerX > 0) {
        circleCenter = {
          x: params.centerX * width,
          y: params.centerY * height
        };
      }

      var yValues = new window.Float32Array(width * 4);

      for (var xi = 0; xi < width * 4; xi++) {
        yValues[xi] = segmentData[0].preEffectData[xi];
      } // var start = performance.now();


      var edgePixels = params.gradual * height;
      var f = height * offset - edgePixels;
      var t = height * offset + edgePixels;
      var tx = 0;
      var ty = 0;
      var edgePreservation = Math.pow(params.preserveEdges, 9) * 33000;

      function doLine(y) {
        var dist = y;
        var v = dist < f ? 0 : dist >= t ? 1 : (dist - f) / (t - f);
        v *= v;

        if (circleCenter) {
          ty = y - circleCenter.y;
          ty *= ty;
        }

        var r = radius * v;
        var ry = 1 / (r + 1);
        var rx = 1 / (0.5 * r + 1);
        var buf = segmentData[~~(y / segHeight)].preEffectData;
        var offs = y % segHeight * width * 4;
        var value1 = buf[offs];
        var value2 = buf[offs + 1];
        var value3 = buf[offs + 2];
        var d1 = 0;
        var d2 = 0;
        var d3 = 0;
        var fact = 1.0;
        var yValOffs = 0;
        var x;

        for (x = 0; x < width; x++) {
          if (circleCenter) {
            tx = x - circleCenter.x;
            dist = Math.sqrt(tx * tx + ty);
            v = dist < f ? 0 : dist >= t ? 1 : (dist - f) / (t - f);
            v *= v;
            r = radius * v;
            ry = 1 / (r + 1);
            rx = 1 / (0.5 * r + 1);
          }

          d1 = buf[offs] - value1;
          d2 = buf[offs + 1] - value2;
          d3 = buf[offs + 2] - value3;

          if (edgePreservation) {
            // dist = Math.pow((d1 * d1 + d2 * d2 + d3 * d3) / 195075, 0.5 * edgePreservation);
            dist = (d1 * d1 + d2 * d2 + d3 * d3) / 195075 * edgePreservation;
            fact = rx + Math.min(dist, 1.0) * (1.0 - rx);
          } else {
            fact = rx;
          }

          buf[offs] = value1 += d1 * fact;
          buf[offs + 1] = value2 += d2 * fact;
          buf[offs + 2] = value3 += d3 * fact;
          yValOffs += 4;
          offs += 4;
        }

        for (x = 0; x < width; x++) {
          if (circleCenter) {
            tx = width - x - circleCenter.x;
            dist = Math.sqrt(tx * tx + ty);
            v = dist < f ? 0 : dist >= t ? 1 : (dist - f) / (t - f);
            v *= v;
            r = radius * v;
            ry = 1 / (r + 1);
            rx = 1 / (0.5 * r + 1);
          }

          yValOffs -= 4;
          offs -= 4;
          d1 = buf[offs] - value1;
          d2 = buf[offs + 1] - value2;
          d3 = buf[offs + 2] - value3;

          if (edgePreservation) {
            // dist = Math.pow((d1 * d1 + d2 * d2 + d3 * d3) / 195075, 0.5 * edgePreservation);
            dist = (d1 * d1 + d2 * d2 + d3 * d3) / 195075 * edgePreservation;
            fact = rx + Math.min(dist, 1.0) * (1.0 - rx);
          } else {
            fact = rx;
          }

          value1 += d1 * fact;
          value2 += d2 * fact;
          value3 += d3 * fact;
          d1 = value1 - yValues[yValOffs];
          d2 = value2 - yValues[yValOffs + 1];
          d3 = value3 - yValues[yValOffs + 2];

          if (edgePreservation) {
            // dist = Math.pow((d1 * d1 + d2 * d2 + d3 * d3) / 195075, 0.5 * edgePreservation);
            dist = (d1 * d1 + d2 * d2 + d3 * d3) / 195075 * edgePreservation;
            fact = rx + Math.min(dist, 1.0) * (1.0 - rx);
          } else {
            fact = ry;
          }

          buf[offs] = yValues[yValOffs] += d1 * fact;
          buf[offs + 1] = yValues[yValOffs + 1] += d2 * fact;
          buf[offs + 2] = yValues[yValOffs + 2] += d3 * fact;
        }
      }

      var extraWorkToDo = [];
      var h = segHeight;
      var segCount = segmentData.length;

      function doForward(start, stop) {
        for (var y = start; y < stop; y++) {
          doLine(y);
        }
      }

      function doBackwards(start, stop) {
        for (var y = start - 1; y >= stop; y--) {
          doLine(y);
        }
      }

      for (var i = segCount - 1; i >= 0; i--) {
        offset = segHeight * i;

        if (i === segCount - 1) {
          h = height - (segCount - 1) * segHeight;
        } else {
          h = segHeight;
        }

        var st = i * segHeight;
        extraWorkToDo.unshift(doForward.bind(null, st, st + h));
        extraWorkToDo.push(doBackwards.bind(null, st + h, st));
      }

      return extraWorkToDo;
    }
  }
};
var templateBody = 'var w = msg.w;' + 'var h = msg.h;' + 'var d = msg.data;' + 'var r = 0, g = 0, b = 0, a = 255;' + 'for (var y = 0, x = 0, o = 0, bw; y < h; y++)' + '    for (x = 0; x < w; x++) {' + '        o = y * w + x;' + '        o *= 4;' + '        r = d[o]; g = d[o + 1]; b = d[o + 2]; a = d[o + 3];' + '        effectBodiesHere();' + '        d[o] = r; d[o + 1] = g; d[o + 2] = b; d[o + 3] = a;' + '    }';
var effectFuncCache = Object.create(null);

function AMImageEffects() {
  var self = this;
  var source = null;
  var output = document.createElement('canvas');
  var context = null;
  var segCount = 48 | 0;
  var segHeight = 16 | 0;
  var openSegments = 0;
  var segmentData = [];
  var workers = null;
  var effects = Object.create(null);
  var effectsKey = '';
  var effectsFunc = null;
  var effectsFuncNeedsUpdate = true;
  var lastPreEffects = Object.create(null);
  var startTime = 0;
  var sceduledUpdateTimer = null;
  var imageDataSupported = false;
  self.scale = 1.0 // Test for ImageData contructor support
  ;

  (function () {
    try {
      var id = new window.ImageData(new window.Uint8ClampedArray([128, 128, 128, 128]), 1, 1);
      imageDataSupported = Object.hasOwnProperty.call(id, 'data');
    } catch (err) {
      console.log('No image data constructor support available');
    }
  })();

  function handleWorkerResult(workerResult) {
    var sd = segmentData[workerResult.data.ix];

    if (imageDataSupported) {
      sd.pixelData = new window.ImageData(workerResult.data.data, sd.pixelData.width, sd.pixelData.height);
    } else {
      sd.pixelData.data.set(workerResult.data.data);
    }

    context.putImageData(sd.pixelData, 0, sd.offset);

    if (--openSegments === 0 && window.amdebug) {
      console.log("finished: ".concat((Date.now() - startTime).toFixed(2)));
    }
  }

  var SegmentData = /*#__PURE__*/function () {
    function SegmentData(ix, pixelData, offset) {
      (0, _classCallCheck2["default"])(this, SegmentData);
      this.pixelData = pixelData;
      this.originalData = new window.Uint8ClampedArray(pixelData.data);
      this.preEffectData = this.originalData;
      this.offset = offset;
      this.workerSceduled = null;
      this.ix = ix;
    }

    (0, _createClass2["default"])(SegmentData, [{
      key: "startWorker",
      value: function startWorker() {
        var self2 = this;
        var msg = {
          functionName: effectsKey,
          ix: self2.ix,
          w: self2.pixelData.width,
          h: self2.pixelData.height,
          data: self2.pixelData.data,
          effects: effects
        };
        openSegments++;

        if (workers && effectsFunc) {
          if (window.amdebug) {
            console.log("postedWork[".concat(msg.ix, "]: ").concat(msg.functionName));
          }

          if (imageDataSupported) {
            workers.postMessage(msg, [msg.data.buffer]);
          } else {
            workers.postMessage(msg);
          }
        } else {
          sceduleWork(function () {
            if (self2.pixelData) {
              if (window.amdebug) {
                console.log("startWorker[".concat(msg.ix, "]: ").concat(msg.functionName));
              }

              if (effectsFunc) {
                effectsFunc(msg);
              }

              handleWorkerResult({
                data: msg
              });
            }
          });
        }
      }
    }]);
    return SegmentData;
  }();

  function updateEffectsFunction() {
    if (effectsFuncNeedsUpdate) {
      effectsFuncNeedsUpdate = false;
      var initScripts = [];
      var bodyScripts = [];
      var eff = '';
      effectsKey = '';

      for (eff in effectTemplates) {
        if (Object.hasOwnProperty.call(effects, eff)) {
          if (effectTemplates[eff].body) {
            effectsKey += "_".concat(eff);
          }
        }
      }

      if (effectsKey === '') {
        effectsFunc = null;
        return;
      }

      if (Object.hasOwnProperty.call(effectFuncCache, effectsKey)) {
        effectsFunc = effectFuncCache[effectsKey];
        return;
      }

      for (eff in effectTemplates) {
        if (Object.hasOwnProperty.call(effects, eff)) {
          var template = effectTemplates[eff];
          if (template.init) initScripts.push(template.init);
          if (template.body) bodyScripts.push(template.body);
        }
      }

      if (bodyScripts.length !== 0) {
        initScripts.push(templateBody.replace('effectBodiesHere();', bodyScripts.join('')));
        var effectsFuncStr = initScripts.join('');
        var FN = Function;
        effectsFunc = FN('msg', effectsFuncStr);

        if (typeof window.AMWorkers !== 'undefined' && window.AMWorkers.isSupported()) {
          if (!workers) {
            workers = new window.AMWorkers(handleWorkerResult);
          }

          workers.addFunction(effectsKey, effectsFuncStr);
        }
      }

      effectFuncCache[effectsKey] = effectsFunc;
    }
  }

  var triggerUpdate = null;

  function sceduleUpdate() {
    if (!sceduledUpdateTimer) {
      sceduledUpdateTimer = setTimeout(function () {
        triggerUpdate();
        sceduledUpdateTimer = null;
        return null;
      }, 12);
    }
  }

  function doPreInit() {
    if (window.amdebug) {
      console.log('preInit');
    }

    for (var i = 0; i < segmentData.length; i++) {
      if (segmentData[i].preEffectData === segmentData[i].originalData) {
        segmentData[i].preEffectData = new window.Uint8ClampedArray(segmentData[i].originalData);
      } else {
        segmentData[i].preEffectData.set(segmentData[i].originalData);
      }
    }
  }

  triggerUpdate = function triggerUpdate() {
    if (openSegments >= segmentData.length) {
      sceduleUpdate();
    } else {
      startTime = Date.now();
      var preEffectChanged = false;
      var eff = '';

      for (eff in effectTemplates) {
        if (Object.hasOwnProperty.call(effects, eff)) {
          if (effectTemplates[eff].preEffect) {
            if (!compareByValue(lastPreEffects[eff], effects[eff])) {
              preEffectChanged = true;
              lastPreEffects[eff] = JSON.parse(JSON.stringify(effects[eff]));
            }
          }
        }
      }

      for (eff in lastPreEffects) {
        if (!Object.hasOwnProperty.call(effects, eff)) {
          preEffectChanged = true;
          delete lastPreEffects[eff];
        }
      }

      openSegments += 100;

      if (preEffectChanged) {
        sceduleWork(doPreInit);

        var schedule = function (effectName) {
          if (window.amdebug) {
            console.log("preEffect: ".concat(effectName), effects[effectName]);
          }

          var moreWork = effectTemplates[effectName].preEffect(segmentData, segHeight, 0, 0, output.width, output.height, effects[effectName]);

          if (moreWork && moreWork.length > 0) {
            sceduleWorkBefore(moreWork);
          }
        }.bind(self, eff);

        for (eff in effectTemplates) {
          if (Object.hasOwnProperty.call(effects, eff)) {
            if (effectTemplates[eff].preEffect) {
              sceduleWork(schedule);
            }
          }
        }
      }

      sceduleWork(function () {
        if (window.amdebug) {
          console.log('initBuffers');
        }

        var i = 0;

        for (i = 0; i < segmentData.length; i++) {
          segmentData[i].pixelData.data.set(segmentData[i].preEffectData);
        }

        updateEffectsFunction();
        openSegments -= 100;

        for (i = 0; i < segmentData.length; i++) {
          segmentData[i].startWorker();
        }

        sceduleWork(function () {
          self.onComplete(output);
        });
      });
    }
  };

  function getEffectTemplateValue(path, name) {
    var pi = path.indexOf('.');

    if (pi !== -1) {
      var effectName = path.slice(0, pi);
      return getFromPath(effectTemplates[effectName][name], path.slice(pi + 1));
    } else {
      return effectTemplates[path][name];
    }
  }

  function getEffectValue(path) {
    var pi = path.indexOf('.');
    var name = path;

    if (pi !== -1) {
      name = path.slice(0, pi);
    }

    if (!Object.hasOwnProperty.call(effects, name)) {
      return getEffectTemplateValue(path, 'defaultValue');
    }

    if (pi !== -1) {
      return getFromPath(effects[name], path.slice(pi + 1));
    } else {
      return effects[name];
    }
  }

  function setEffectValue(path, value) {
    var pi = path.indexOf('.');
    var name = path;

    if (pi !== -1) {
      name = path.slice(0, pi);
    }

    if (value !== effects[name]) {
      var defaultValue = getEffectTemplateValue(name, 'defaultValue');

      if (value == null || !isNaN(defaultValue) && Math.abs(value - defaultValue) < 0.001 && pi === -1) {
        delete effects[name];
        effectsFuncNeedsUpdate = true;
      } else {
        if (!Object.hasOwnProperty.call(effects, name)) {
          effectsFuncNeedsUpdate = true;
        }

        if (pi !== -1) {
          if (!Object.hasOwnProperty.call(effects, name)) {
            effects[name] = JSON.parse(JSON.stringify(defaultValue));
          }

          setOnPath(effects[name], path.slice(pi + 1), value);
        } else {
          effects[name] = value;
        }
      }

      if (window.amdebug) {
        console.log("set ".concat(path, "="), value);

        if (console.table) {
          if (value && value.constructor === Array) {
            console.table(value);
          }
        }
      }

      sceduleUpdate();
    }
  }

  self.originalWidth = -1;
  self.originalHeight = -1;

  self.setSource = function (src, desiredWidth, desiredHeight) {
    source = src;
    return self.updateSize(desiredWidth, desiredHeight);
  };

  self.updateSize = function (desiredWidth, desiredHeight) {
    // container = document.createElement('div');
    self.originalWidth = source.width;
    self.originalHeight = source.height;

    if (!desiredWidth) {
      output.width = source.width;
      output.height = source.height;
    } else {
      output.width = desiredWidth;

      if (desiredHeight) {
        output.height = desiredHeight;
      } else {
        output.height = source.height * desiredWidth / source.width;
      }
    }

    self.scale = output.width / source.width;
    context = output.getContext('2d');
    var sourceHeight = source.height * output.width / source.width;
    context.drawImage(source, 0, 0, source.width, source.height, 0, 0, output.width, sourceHeight);

    if (sourceHeight < output.height) {
      context.scale(1, -1);
      context.drawImage(source, 0, 0, source.width, source.height, 0, -sourceHeight, output.width, -(output.height - sourceHeight));
      context.scale(1, 1);
    } // Max 2MB per worker


    segCount = Math.ceil(output.width * output.height / (512 * 1024));
    segHeight = Math.ceil(output.height / segCount);
    var offset = 0;
    var h = segHeight;
    var i = 0;

    for (i = 0; i < segmentData.length; i++) {
      segmentData[i].originalData = null;
      segmentData[i].pixelData = null;
    }

    openSegments = 0;
    segmentData = [];
    lastPreEffects = Object.create(null);

    for (i = 0; i < segCount; i++) {
      offset = segHeight * i;

      if (i === segCount - 1) {
        h = output.height - (segCount - 1) * segHeight;
      }

      var segData = new SegmentData(segmentData.length, context.getImageData(0, offset, output.width, h), offset);
      segmentData.push(segData);
    }

    sceduleUpdate();
    return output;
  };

  self.getSegCount = function () {
    return segmentData.length;
  };

  self.getSegData = function (i) {
    return segmentData[i];
  };

  self.assign = function (imageeffects) {
    // openSegments = 0;
    // segmentData = [];
    for (var i = 0; i < imageeffects.getSegCount(); i++) {
      var sd = imageeffects.getSegData(i);
      segmentData[i].originalData = sd.originalData;
      segmentData[i].preEffectData = sd.originalData;
    }

    sceduleUpdate();
  };

  self.apply = function () {
    for (var i = 0; i < segCount; i++) {
      segmentData[i].originalData.set(segmentData[i].pixelData.data);
    }

    lastPreEffects = Object.create(null);
    sceduleUpdate();
  };

  self.remove = function (name) {
    setEffectValue(name, null);
  };

  self.set = function (name, value, finished) {
    setEffectValue(name, value);

    if (finished) {
      self.onFinishedChange();
    }
  };

  self.get = function (name) {
    return getEffectValue(name);
  };

  self.getAll = function () {
    return effects;
  };

  self.setAll = function (newEffects, resetOld) {
    if (resetOld) {
      for (var eff in effects) {
        if (Object.hasOwnProperty.call(effectTemplates, eff)) {
          if ((0, _typeof2["default"])(effects[eff]) === 'object') {
            extendRecursive(effects[eff], effectTemplates[eff].defaultValue, true);
          } else {
            effects[eff] = effectTemplates[eff].defaultValue;
          }
        }
      }
    }

    extendRecursive(effects, newEffects, true);
    effectsKey = '';
    effectsFunc = null;
    effectsFuncNeedsUpdate = true;
    lastPreEffects = Object.create(null);
    self.onFinishedChange();
    sceduleUpdate();
  };

  self.getMin = function (name) {
    return getEffectTemplateValue(name, 'minValue');
  };

  self.getMax = function (name) {
    return getEffectTemplateValue(name, 'maxValue');
  };

  self.getDefault = function (name) {
    return getEffectTemplateValue(name, 'defaultValue');
  };

  self.getEffectTemplates = function () {
    var result = [];

    for (var eff in effectTemplates) {
      var effect = effectTemplates[eff];
      result.push({
        name: eff,
        defaultValue: effect.defaultValue,
        minValue: effect.minValue,
        maxValue: effect.maxValue
      });
    }

    return result;
  };

  self.onComplete = function (_) {};

  self.onFinishedChange = function (_) {};
}

var _default = AMImageEffects;
exports["default"] = _default;